var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 8,
    fill: "none",
    viewBox: "0 0 11 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0.183313 4.56741L3.44963 7.818C3.69428 8.06147 4.09 8.06056 4.33353 7.81588C4.57703 7.57122 4.57609 7.1755 4.33144 6.932L2.13881 4.75001L10.375 4.75001C10.7202 4.75001 11 4.47019 11 4.12501C11 3.77982 10.7202 3.50001 10.375 3.50001L2.13884 3.50001L4.33141 1.31801C4.57606 1.07451 4.577 0.678793 4.3335 0.434137C4.08997 0.189418 3.69422 0.188575 3.44959 0.432012L0.183844 3.68201C-0.0609375 3.92632 -0.0607182 4.32391 0.183313 4.56741Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.0f8a8149b7b249c3c3fd40418cfc7856.svg";
export { ForwardRef as ReactComponent };